import './MiniAccordionTable.scss';
import {HomePlant} from '../../Services/typescript-fetch-client';
import decimalRound from "../../Utils/decimalRound";
import formatNumber from "../../Utils/formatNumber";
import { ReactComponent as WindSvg} from  '../ui-components/icons/Eolico_active.svg'
import { ReactComponent as BioSvg} from  '../ui-components/icons/Bioenergie_active.svg'
import { ReactComponent as GasSvg} from  '../ui-components/icons/Gas_active.svg'
import { ReactComponent as SorgeniaSvg} from  '../ui-components/icons/Sorgenia_general.svg'
import { ReactComponent as SolarSvg} from  '../ui-components/icons/Fotovoltaico_active.svg'

type Props = {
    homePlants: HomePlant[]
};

const MiniAccordionTable = (props: Props) => {
    const derivedTypes = Array.from(new Set(props.homePlants.map((item) => item.type?.toString())));
    const currentObjects = derivedTypes.map(type => {
        return {colspan: 1, type}
    })

    function makeHeader(types: ({colspan: number | null, type: string | undefined})[]){
        const fixedTypes: ({colspan: number | null, type: string | undefined})[] = [{colspan: 2, type: "logo"}, {colspan: null, type: "total"}];
        const currentTypes = fixedTypes.concat(types);
        return currentTypes.map((type) => {
            if (type) {
                return (
                    <th className='th-first-col' colSpan={type.colspan ?? 1} key={type.type} scope={"col"}>
                    {mapTechnologyIcon(type.type ?? "")}
                    </th>
                ); 
            } else {
                return null
            }
        });
    }

    function mapTechnologyIcon(name: HomePlant.TypeEnum | string){
        switch (name){
            default:
            case HomePlant.TypeEnum.Ccgt: return <GasSvg />;
            case HomePlant.TypeEnum.Bioenergy: return <BioSvg />;
            case HomePlant.TypeEnum.Wind: return <WindSvg />;
            case HomePlant.TypeEnum.Solar: return <SolarSvg />;
            case "total": return <SorgeniaSvg />;
            case "logo": return (
                <div><img alt="Logo sorgenia" src="/LogoSorgenia.png" /></div>
            );
        }
    }

    function producedEnergyToday() {
        return (<>
            <td className="td-first-col">EE prodotta oggi</td>
            <td className='td-second-col'>MWh</td>
            <td style={{textAlign:"center"}}>{formatNumber(decimalRound(props.homePlants.reduce((acc, hp) => { return acc + hp.eeToday!; }, 0), 0))}</td>
            {derivedTypes.map(t => <td className='row-last-td' key={t}>{formatNumber(decimalRound(props.homePlants.filter(hp => hp.type === t).reduce((acc, hp) => { return acc + hp.eeToday!; }, 0), 0))}</td>)}
        </>)
    }

    function expectedEnergyToday() {
        return (<>
            <td className="td-first-col">EE attesa per oggi</td>
            <td className='td-second-col'>MWh</td>
            <td style={{textAlign:"center"}}>{formatNumber(decimalRound(props.homePlants.reduce((acc, hp) => { return acc + hp.prodExpectedToday!; }, 0), 0))}</td>
            {derivedTypes.map(t => <td className='row-last-td' key={t}>{formatNumber(decimalRound(props.homePlants.filter(hp => hp.type === t).reduce((acc, hp) => { return acc + hp.prodExpectedToday!; }, 0), 0))}</td>)}
        </>)
    }

    function totalImplants() {
        return (<>
            <td style={{borderWidth:"0px 2px 4px 4px", borderStyle: "solid", borderColor: "#12256a", borderRadius: "0 0 0 10px" }} className="td-first-col" colSpan={2}>Impianti in marcia</td>
            <td style={{borderWidth:"0px 1px 4px", textAlign:"center"}}>{props.homePlants.reduce((acc, hp) => { return acc + Number(hp.onProd!); }, 0) + "/" + props.homePlants.length}</td>
            {derivedTypes.map(t => <td className='last-row-last-td' key={t}>{formatNumber(decimalRound(props.homePlants.filter(hp => hp.type === t).reduce((acc, hp) => { return acc + Number(hp.onProd!); }, 0), 0) + "/" + props.homePlants.filter(hp => hp.type === t).length)}</td>)}
        </>)
    }
    
    return (
            <table cellPadding={0} cellSpacing={0} id="mini-table">
                <thead>
                    <tr style={{border:"1px solid #12256a"}}>{makeHeader(currentObjects)}</tr>
                </thead>
                <tbody>
                <tr>{producedEnergyToday()}</tr>
                <tr>{expectedEnergyToday()}</tr>
                <tr>{totalImplants()}</tr>
                </tbody>
            </table>
    );
}

export default MiniAccordionTable;